import {
  Flex,
  Text,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';

import {RulesIcon2} from '../../icons/RulesIcon2';
import {useTranslate} from '@eksab/i18n';
import {TriviaTopic} from '../../types';

export const RulesModal = ({isOpen, onClose, topic}: {isOpen: boolean; onClose: () => void; topic: TriviaTopic}) => {
  const t = useTranslate();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex gap="3">
            <RulesIcon2 />
            <Flex flexDir="column" justifyContent="space-between">
              <Text fontSize="small" color="#8f8f8f" fontWeight="semibold">
                {t('trivia.rules.check_before_playing')}
              </Text>
              <Text fontSize="2xl" fontWeight="bold">
                {t('trivia.rules.rules')}
              </Text>
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalBody overflowY="scroll" maxH="600px">
          <UnorderedList>
            <ListItem>{t(`trivia.rules.1.${topic}`)}</ListItem>
            <ListItem>{t('trivia.rules.2')}</ListItem>
            <ListItem>{t('trivia.rules.3')}</ListItem>
            <ListItem>{t('trivia.rules.4')}</ListItem>
            <ListItem>{t('trivia.rules.5')}</ListItem>
            <ListItem>{t('trivia.rules.6')}</ListItem>
            <ListItem>{t('trivia.rules.7')}</ListItem>
            <ListItem>{t('trivia.rules.8')}</ListItem>
            <ListItem>{t('trivia.rules.9')}</ListItem>
            <ListItem>{t('trivia.rules.10')}</ListItem>
          </UnorderedList>
        </ModalBody>

        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
};
